import { ContractsTable } from "components";

const Contract = () => {
    return <ContractsTable />;
}

export default Contract;
